import { useDashboardAnalytics, useOrders } from '@/api';
import { MetricCard } from '@/components/atoms';
import { formatCurrency } from '@/lib/helpers';

interface MetricsProps {
  startDate?: string;
  endDate?: string;
}

export const Metrics = ({ startDate, endDate }: MetricsProps) => {
  const { data } = useDashboardAnalytics(startDate, endDate);
  const { data: ordersPage } = useOrders();

  return (
    <div className="grid grid-cols-12 gap-2.5 col-span-1 row-span-4 md:row-span-2 xl:row-span-1">
      <MetricCard
        variant="primary"
        name="Total sales"
        value={formatCurrency(data?.sales?.total || 0)}
        icon="Tag"
        trend={
          data && data?.sales?.percentage == 0
            ? 'flat'
            : data && data?.sales?.percentage > 0
              ? 'up'
              : 'down'
        }
        trendValue={
          data?.sales?.percentage ? `${data?.sales?.percentage}%` : '0%'
        }
        className="col-span-6 xl:col-span-3"
      />
      <MetricCard
        variant="blue"
        name="Conversations"
        value={data?.conversations?.total || 0}
        icon="MessagesSquare"
        trend={
          data && data?.conversations?.percentage == 0
            ? 'flat'
            : data && data?.conversations?.percentage > 0
              ? 'up'
              : 'down'
        }
        trendValue={
          data?.conversations?.percentage
            ? `${data?.conversations?.percentage}%`
            : '0%'
        }
        className="col-span-6 xl:col-span-3"
      />
      <MetricCard
        variant="amber"
        name="Total customers"
        value={data?.customers?.total || 0}
        icon="ShoppingBag"
        trend={
          data && data?.customers?.percentage == 0
            ? 'flat'
            : data && data?.customers?.percentage > 0
              ? 'up'
              : 'down'
        }
        trendValue={
          data?.customers?.percentage ? `${data?.customers?.percentage}%` : '0%'
        }
        className="col-span-6 xl:col-span-3"
      />
      <MetricCard
        variant="purple"
        name="Total orders"
        value={ordersPage?.total || 0}
        icon="Repeat"
        trend="flat"
        trendValue="0%"
        className="col-span-6 xl:col-span-3"
      />
    </div>
  );
};
